import React from 'react';

export class Valuer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(evt, value) {
        this.setState({
            value
        });
    }

    render() {
        const { children } = this.props;
        const { value } = this.state;
        const onChange = this.handleChange;
        let displayValue = value;
        if (Array.isArray(value)) {
            displayValue = value.reduce((acc, cur, idx) => {
                const delimiter = idx > 0 ? ', ' : '';
                return `${acc}${delimiter}${cur}`;
            }, '');
        }
        return (
            <div>
                <dl>
                    <dt>Value:</dt>
                    <dd>{displayValue}</dd>
                </dl>
                <div>{React.cloneElement(children, { value, onChange })}</div>
            </div>
        );
    }
}
